
export function convertPhoneIntoString(phone) {
  let newPhone = '';
  if (phone.number) {
    newPhone = '+' + phone.countryCode + phone.number;
  }

  return newPhone;
}
